import { createFileRoute } from '@tanstack/react-router';
import { API_CONFIG } from '@/lib/config';

import 'opaz-gis-zsm-component/dist/assets/zone-selection-map.css';
import { lazy, Suspense } from 'react';
import { Container } from '@/components/container';
import { Skeleton } from '@opaz/ui-components';
import { useTranslation } from 'react-i18next';

const ZoneSelectionMap = lazy(() =>
  import('opaz-gis-zsm-component').then((module) => ({
    default: module.ZoneSelectionMap,
  })),
);

export const Route = createFileRoute('/zones/')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Zones - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  const { i18n } = useTranslation();

  return (
    <Suspense
      fallback={
        <Container>
          <Skeleton className="h-[400px] w-full" />
        </Container>
      }
    >
      <ZoneSelectionMap
        style={{ height: '100vh', width: '100wh', position: 'relative' }}
        cmsUrl={API_CONFIG.GIS_CMS_URL}
        baseUrl={API_CONFIG.GIS_BASE_URL}
        languageId={i18n.language}
      />
    </Suspense>
  );
}
